import React from 'react';
import RatingSelector from 'components/commercetools-ui/atoms/rating-selector';

type ReviewHeading = 'h4' | 'h5' | 'h6';
export interface ReviewProps {
  id: string;
  title: string;
  createdAt: string;
  rating: number;
  description?: string;
  author: string;
  className?: string;
  reviewHeading?: ReviewHeading;
}

export const Review: React.FC<ReviewProps> = ({
  title,
  createdAt,
  rating,
  description,
  author,
  className = '',
  reviewHeading = 'h5',
}) => {
  const HeadingTag = reviewHeading as keyof JSX.IntrinsicElements;

  return (
    <div className={`flex flex-col gap-8 ${className}`}>
      <div className="flex items-center justify-between">
        <RatingSelector
          value={rating}
          disabled={true}
          className="flex gap-4"
          starProps={{
            size: 16,
            strokeVariant: 'matching',
          }}
        />
        <p className="body-text-small text-text-tertiary">{createdAt}</p>
      </div>

      <HeadingTag className="body-text-medium font-medium">{title}</HeadingTag>

      {description && <p className="body-text text-text-tertiary">{description}</p>}

      <p className="body-text font-medium text-text-tertiary">{author}</p>
    </div>
  );
};

export default Review;
